// extracted by mini-css-extract-plugin
module.exports = {"card":"card___4fH8J","label":"label___KIAWn","content":"content___3VF0H","comment":"comment___i00Oc"};